/* 不使用 */
import { createApp } from 'vue';
import App from './App.vue';

import "bootstrap";
import "@/admin/scss/app.scss";

createApp(App)
.mount('#app');
